import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useHouseholdId } from '@/shared/hooks'
import { GROCERY_LIST_QUERY_KEY } from './useGroceryList'

export function useGroceryListRealtime() {
  const queryClient = useQueryClient()
  const { householdId } = useHouseholdId()

  useEffect(() => {
    if (!householdId) return

    const channel = supabase
      .channel(`grocery-list-${householdId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'grocery_list_items',
          filter: `household_id=eq.${householdId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: GROCERY_LIST_QUERY_KEY })
        },
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [householdId, queryClient])
}
